<template>
  <client-only>
    <VueTelInput
      v-model="model"
      mode="international"
      valid-characters-only
      class="!rounded-lg h-11 !shadow-sm !border-0 ring-input-border-light ring-1 dark:ring-input-border-dark"
      defaultCountry="FR"
      :preferredCountries="[
        'FR',
        'BE',
        'CH',
        'DE',
        'ES',
        'IT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SE',
        'TR',
      ]"
      v-bind="{ ...$attrs, ...$props }"
      :inputOptions="{
        placeholder: $attrs.placeholder,
        ...($attrs.inputOptions ?? {}),
      }"
    />
    <template #fallback>
      <USkeleton class="h-11 w-full !rounded-lg" />
    </template>
  </client-only>
</template>

<script lang="ts" setup>
const VueTelInput = await Promise.all([
  import('vue-tel-input'),
  import('vue-tel-input/vue-tel-input.css'),
]).then(([{ VueTelInput }]) => VueTelInput)
const model = defineModel<string>()
</script>

<style>
.vti__input {
  @apply !rounded-r-lg;
}
.vue-tel-input:focus-within {
  @apply !ring-primary ring-2;
}
</style>
